// Feedback glyphs: icons only "Give feedback" and "Report this" use
// (docs/implement/lanes.md). Key = the icon's name, value = Lucide geometry,
// as in Icon.tsx.

export { feedbackGlyphs };

import {
    Bug,
    Lightbulb,
    MessageSquareHeart,
    MessageSquareWarning,
} from "lucide-react";
import type { AreaGlyphs } from "../Icon";

const feedbackGlyphs = {
    feedback: MessageSquareWarning, // report an error
    "give-feedback": MessageSquareHeart, // the Help menu's Give feedback
    "feedback-problem": Bug, // a problem report
    "feedback-idea": Lightbulb, // an idea
} satisfies AreaGlyphs;
